import type { SVGProps } from 'react';

export function SafeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.387 11.994h-2.06c-.617 0-1.113.5-1.113 1.113v2.989c0 .617-.5 1.113-1.113 1.113H7.899c-.617 0-1.113.5-1.113 1.113v2.065c0 .617.5 1.113 1.113 1.113h8.672c.617 0 1.105-.5 1.105-1.113v-1.651c0-.617.5-1.051 1.113-1.051h1.598c.617 0 1.113-.5 1.113-1.113v-3.473c0-.622-.5-1.105-1.113-1.105M6.786 7.899c0-.617.5-1.113 1.113-1.113h8.193c.617 0 1.113-.5 1.113-1.113v-2.06c0-.617-.5-1.113-1.113-1.113H7.424c-.617 0-1.113.5-1.113 1.113v1.589c0 .617-.5 1.113-1.113 1.113H3.614c-.617 0-1.113.5-1.113 1.113v3.477c0 .617.5 1.088 1.117 1.088h2.06c.617 0 1.113-.5 1.113-1.113zM11.026 9.83h1.981c.646 0 1.167.525 1.167 1.167v1.98c0 .646-.525 1.167-1.167 1.167h-1.98a1.17 1.17 0 0 1-1.167-1.167v-1.98a1.166 1.166 0 0 1 1.166-1.167" />
    </svg>
  );
}
